const API_URL =
  document.domain === "localhost"
    ? "https://jccreations.boutique"
    : "https://jccreations.boutique";

const Apis = {
  //Authentication api
  GetUserLogin: `${API_URL}/api/auth/rootLogin`,
  GetUserRegsiter: `${API_URL}/api/auth/register`,
  GetAllUserList: `${API_URL}/api/auth/user/getAllUserList`,
  GetUserUpdate: `${API_URL}/api/auth/user/update`,
  GetDeleteUserList: `${API_URL}/api/auth/user/delete`,

  //category api
  CreateCategoryList: `${API_URL}/api/category/create`,
  GetAllCategoryList: `${API_URL}/api/category/main-list`,
  GetUpdateCategoryList: `${API_URL}/api/category/main-list/update`,

  //product api
  AddProductList: `${API_URL}/api/product/add`,
  ZipUploads: `${API_URL}/api/product/zipuploads`,
  GetAllProductList: `${API_URL}/api/product/getAllproductList`,
  GetUpdateProduct: `${API_URL}/api/product/update`,
  GetDeleteProduct: `${API_URL}/api/product/delete`,
  GetProductById: `${API_URL}/api/product/getProductById`,
  GetProductQuerySearchList: `${API_URL}/api/product/search-products?q=`,
  GetAllProductCount: `${API_URL}/api/product/getproductcount`,
  CreateCategoryProductsPdf: `${API_URL}/api/product/createCategoryPDF`,
  GetAdmProductListById: `${API_URL}/api/product/getAdmProductById`,

  //order detail
  GetAllStatusOrder: `${API_URL}/api/order/count`,
  GetAllOrderDetails: `${API_URL}/api/order/adminlist-by-phone-or-email`,
  GETrazorOrderInfo: `${API_URL}/api/order/fetchRazorpayOrder`,
  GetOrderMatch: `${API_URL}/api/order/check-order`,
  CreateAdminOrder: `${API_URL}/api/order/admincreate-order`,

  //preorder details
  GetAllPreOrderDetails: `${API_URL}/api/order/getpreorder`,
  GetPreOrderUpdate: `${API_URL}/api/order/movepreorder`,
  GetPreOrderDelete: `${API_URL}/api/order/deletepreorder`,
  GetPreorderCron: `${API_URL}/api/order/preorder-cron`,

  // customer details
  GetAdminUserLogin: `${API_URL}/api/customer/adminloginasuser`,
  GetAllCustomerDetails: `${API_URL}/api/customer/list`,
  GetCustomerBySearch: `${API_URL}/api/customer/searchcustomers`,
  GetCustomerUpdateDetails: `${API_URL}/api/customer/update`,
  GetCustomerDeleteById: `${API_URL}/api/customer/delete`,
  Resetpassword: `${API_URL}/api/customer/resetPassword`,
  GetAllCustomerCount: `${API_URL}/api/customer/customercount`,

  //payment list
  GetAllPaymentList: `${API_URL}/api/payment/getAllPayment`,
  GetAllPaymentCount: `${API_URL}/api/payment/totalincome`,

  //wallet details
  GetWalletPackageAdd: `${API_URL}/api/wallet/package/add`,
  GetAllWalletPackageList: `${API_URL}/api/wallet/package/list`,
  GetWalletPackageUpdate: `${API_URL}/api/wallet/package/update`,
  GetWalletPackageDelete: `${API_URL}/api/wallet/package/delete`,
  GetWalletTransactions: `${API_URL}/api/wallet/admin-wallet-transactions-by-phone-or-email`,
  adminWalletTopup: `${API_URL}/api/wallet/admin/topupwallets`,

  //ticket details
  GetAllTickets: `${API_URL}/api/ticket/ticketadminall`,
  GetTicketById: `${API_URL}/api/ticket/ticketdetails`,
  UpdateTicketStatus: `${API_URL}/api/ticket/ticketupdate`,
  SendTicketReply: `${API_URL}/api/ticket/reply`,
};
export { API_URL, Apis };



// WEBPACK FOOTER //
// ./src/config/index.js